// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".25272599fd1cd5b4b24988fe918ca875ed2f1816.chunk.bundle.js";
};